import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CHECKOUT_URLS } from '../lib/checkoutLinks';
import { Check, Leaf } from 'lucide-react';
import { TropicalLeaf } from './botanical/TropicalLeaf';
import { Eucalyptus } from './botanical/Eucalyptus';
export function Hero() {
  const benefits = ['100% PDF', 'Acceso en 5 minutos', 'Ingredientes del súper o dietética', 'Para toda la familia', 'Más de 80 protocolos naturales'];
  return <Section className="pt-12 md:pt-20 pb-16 bg-forest-mist relative overflow-hidden" data-id="element-284">
      {/* Botanical Background Elements */}
      <TropicalLeaf className="absolute -top-20 -left-20 w-96 h-96 text-moss opacity-10 blur-sm rotate-45" data-id="element-285" />
      <Eucalyptus className="absolute top-40 -right-10 w-64 h-64 text-sage-deep opacity-15 blur-[2px] -rotate-12" data-id="element-286" />

      <div className="max-w-6xl mx-auto relative z-10 grid lg:grid-cols-[1.1fr_1fr] gap-10 lg:gap-16 items-center" data-id="element-287">
        {/* Left column — Content */}
        <div className="text-center lg:text-left" data-id="element-288">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/60 text-forest-deep font-medium text-sm mb-8 border border-sage-mist" data-id="element-289">
            <Leaf className="w-4 h-4 text-moss" data-id="element-290" />
            HOGAR NATURAL™
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-forest-deep leading-tight mb-6 text-balance relative" data-id="element-291">
            Cuando algo duele en casa, ahora sabés qué hacer.
            <svg className="absolute w-48 h-3 -bottom-2 left-1/2 -translate-x-1/2 lg:left-0 lg:translate-x-0 text-honey opacity-50" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-292">
              <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="none" data-id="element-293" />
            </svg>
          </h1>

          <p className="text-lg md:text-xl text-forest/80 mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed text-balance" data-id="element-294">
            El sistema N°1 de remedios naturales para el hogar argentino. Sin
            improvisar. Sin correr a la farmacia a las 11 de la noche. Sin
            quedarte sin saber qué darle a tu familia.
          </p>

          <div className="flex flex-wrap justify-center lg:justify-start gap-3 mb-10" data-id="element-295">
            {benefits.map((benefit, idx) => <div key={idx} className="flex items-center gap-1.5 text-sm md:text-base text-forest-deep font-medium bg-white/80 backdrop-blur-sm px-3 py-1.5 rounded-lg shadow-sm border border-sage-mist" data-id="element-296">
                <Check className="w-4 h-4 text-moss" data-id="element-297" />
                {benefit}
              </div>)}
          </div>

          <div className="flex flex-col items-center lg:items-start gap-3" data-id="element-298">
            <Button variant="cta" size="xl" href={CHECKOUT_URLS.superPack} className="min-w-[280px] sm:min-w-[420px] text-base sm:text-xl tracking-wider" data-id="element-299">
              🔴 QUIERO MI HOGAR NATURAL AHORA
            </Button>
            <div className="flex items-center gap-2 text-xs sm:text-sm font-bold uppercase tracking-widest text-terracotta" data-id="element-300">
              <span className="relative inline-flex h-2.5 w-2.5" data-id="element-301">
                <span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75 animate-ping" data-id="element-302" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" data-id="element-303" />
              </span>
              🔥 Oferta por tiempo limitado
            </div>
          </div>
        </div>

        {/* Right column — Book mockup image */}
        <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.2
      }} className="relative flex justify-center lg:justify-end" data-id="element-304">
          {/* Golden glow behind book */}
          <div aria-hidden="true" className="absolute inset-0 bg-honey/20 blur-3xl rounded-full scale-90" data-id="element-305" />

          <motion.div animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative w-full max-w-[420px] lg:max-w-none" data-id="element-306">
            <img src="https://cdn.magicpatterns.com/uploads/9g9ftWJsteQG1r7DZ97kAX/portada_2_hogar_natural.png" alt="Hogar Natural en Casa — Libro digital con 5 tomos y 5 bonos" className="w-full h-auto rounded-2xl shadow-[0_30px_60px_-15px_rgba(0,0,0,0.4),0_0_40px_-10px_rgba(212,162,76,0.3)] border border-honey/20" data-id="element-307" />
          </motion.div>

          {/* Floating badge */}
          <div className="absolute top-4 -left-2 sm:left-4 bg-honey text-forest-deep px-4 py-2 rounded-full font-bold text-xs sm:text-sm shadow-xl border-2 border-honey-light rotate-[-8deg] z-10" data-id="element-308">
            ⭐ 5 TOMOS + 5 BONOS
          </div>
          <div className="absolute bottom-6 -right-2 sm:right-4 bg-forest-deep text-honey-light px-4 py-2 rounded-full font-bold text-xs sm:text-sm shadow-xl border-2 border-honey/40 rotate-[6deg] z-10" data-id="element-309">
            📲 100% DIGITAL
          </div>
        </motion.div>
      </div>
    </Section>;
}